module.exports = __webpack_public_path__ + "img/abc.a92e3639.png";